/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Create_Project_Label_Description_OptionalInputs */



/**
* | output |
* | --- |
* | "(optional)" |
*
* @param {Create_Project_Label_Description_OptionalInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const create_project_label_description_optional = /** @type {((inputs?: Create_Project_Label_Description_OptionalInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Create_Project_Label_Description_OptionalInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("(optional)")
	return /** @type {LocalizedString} */ ("(optional)")
});